import React, { Component } from "react";

export class Unauthorized extends Component {
    render() {
        return(
            <div className="mt-5 d-flex justify-content-left">
                Unauthorized Page.
            </div>
        )
    }
}